<template>
  <IconListItem icon="location" :label="$t('common.words.orderedin')">
    {{ $t(`licensedterritory.${licensedTerritory}`) }}
  </IconListItem>
</template>

<script lang="ts" setup>
import type { LicensedTerritory } from '@lottocom/lottery-mapping'

export type IconListItemOrderedInProps = {
  licensedTerritory: LicensedTerritory
}

defineProps<IconListItemOrderedInProps>()
</script>
